import i18n from "i18next";

const locale = () => (i18n.language || "fr").startsWith("de") ? "de-CH" : "fr-CH";

export const monthShort = (d: Date) => d.toLocaleDateString(locale(), {month: "short"}).replace(".", "");

export function dateRange(a: Date, b?: Date): string {
    const long = (d: Date, withYear = true) =>
        d.toLocaleDateString(locale(), {day: "numeric", month: "long", ...(withYear ? {year: "numeric"} : {})});
    if (!b || +a === +b) return long(a);
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear())
        return `${a.getDate()}${locale() === "de-CH" ? "." : ""} – ${long(b)}`;
    return `${long(a, a.getFullYear() !== b.getFullYear())} – ${long(b)}`;
}
